import React, { useEffect } from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import Footer from "../Componants/Footer";

const errorMessages = {
    400: "La requête est incorrecte.",
    401: "Non autorisé. Veuillez vous connecter.",
    403: "Accès interdit. Vous n'avez pas les autorisations nécessaires.",
    404: "La ressource demandée est introuvable.",
    408: "La demande a expiré. Veuillez réessayer plus tard.",
    410: "La ressource demandée n'est plus disponible.",
    429: "Trop de requêtes. Veuillez réessayer plus tard.",
    500: "Erreur interne du serveur. Veuillez réessayer plus tard.",
    503: "Service indisponible. Veuillez réessayer plus tard.",
    504: "Délai d'attente dépassé. Veuillez réessayer plus tard."
};

const ErrorView = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const errorCode = location.state?.errorCode;
    const { pageUrl } = useParams();



    const handleLogin = ()=>{
        navigate("/login?target=login");
    }

    const errorMessage = errorMessages[errorCode];

    return (
        <div className="layout-wrapper layout-content-navbar layout-without-menu">
            <div className="layout-container">
                <div className="layout-page">
                    <div className="content-wrapper">
                        <div className="container-xxl flex-grow-1 container-p-y justify-content-center align-content-center">
                            <div className="layout-demo-wrapper d-flex">
                                <div className="mt-4">
                                    <h1 className="display-1" style={{ fontWeight: 'bold', fontSize: 'min(10vw, 100px)' }}>
                                        {"Oops!"}
                                    </h1>
                                </div>
                                <h2 className="mb-2 mx-2">Une erreur inconnue s’est produite.</h2>
                                <div className="mb-4 mx-2 text-muted">
                                    Nous sommes désolés, quelque chose d’inattendu est survenu lors du traitement de votre demande.<br />
                                    Cette erreur peut être temporaire ou liée à un problème technique.<br /><br />
                                    Ce que vous pouvez faire :
                                    <ul>
                                        {errorCode === 401 || errorCode === "401" ? (
                                            <>
                                                <li>Votre session a expiré.</li>
                                                <li>Veuillez vous reconnecter.</li>
                                            </>
                                        ) : (
                                            <>
                                                <li>Vérifiez votre connexion Internet.</li>
                                                <li>Réessayez dans quelques instants.</li>
                                                <li>Si le problème persiste, veuillez nous contacter.</li>
                                            </>
                                        )}
                                    </ul>
                                    <br />
                                    <strong>Code d’erreur :</strong> {errorCode ? errorCode: "ERR-UNEXPECTED"}<br />
                                    <strong>Heure de l’erreur :</strong> {new Date().toLocaleString()}
                                </div>
                                {errorCode === "401" || errorCode === 401 ? (
                                    <button
                                        className="btn btn-netikash mt-4"
                                        onClick={() => handleLogin()}
                                        aria-label="Se Connecter">
                                        <span className="tf-icons bx bx-user"></span>
                                        Se Reconnecter
                                    </button>
                                ):(

                                    <button
                                        className="btn btn-netikash mt-4"
                                        onClick={() => navigate(-1)}
                                        aria-label="Retour">
                                        <span className="tf-icons bx bx-arrow-back"></span>
                                        Retour
                                    </button>
                                )}
                            </div>
                        </div>
                        <div className="content-backdrop fade"></div>
                    </div>
                    <Footer />
                </div>
            </div>
        </div>
    );
};

export default ErrorView;